"use strict";

exports.onRouteUpdate = function (_ref) {
  var location = _ref.location;

  // Wait to ensure page is rendered first.
  setTimeout(function () {
    if (typeof twttr !== "undefined" && window.twttr.widgets && typeof window.twttr.widgets.load === "function") {
      window.twttr.widgets.load();
    }
  }, 0);
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-twitter/gatsby-browser.js
// module id = 416
// module chunks = 231608221292675